import React, { useEffect, useState } from "react";
import {
    CheckboxIcon,
    CrossIcon,
    StyledLabel,
    StyledSelectInput,
    StyledTextInput,
} from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { AvForm, AvGroup } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";
import classnames from "classnames";
import { uuid } from "uuidv4";

import { store as appStore, setIsEdited } from "../../store";
import { store as userStore } from "@components/VerticalLayout/store";

import {
    CustomCardHeader,
    CustomCardBody,
    CustomCardFooter,
} from "@components/Common/CustomCardStyled";

import { ConfirmationEditMessage } from "@components/Common/ConfirmationEditMessage";
import { setSelectedRow } from "@pages/SettingGeneral/Language/store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

type applicationConfigurationType = {
    setIsAddProject: Function;
    setDataIsUpdated: Function;
    isAddProject: boolean;
    isAddNewApplicationButtonClicked: boolean;
    selectedRows: any;
    data: any;
    shopId: string;
};

export function AddProject({
    setIsAddProject,
    isAddProject,
    setDataIsUpdated,
    isAddNewApplicationButtonClicked,
    selectedRows,
    data,
    shopId,
}: applicationConfigurationType) {
    const { t } = useTranslation();
    const {
        oneShop,
        userID,
        franchiseID,
        shopID,
        operatorID,
        shopName,
    } = useSnapshot(userStore);
    const { isEdited, isPlusIconClicked } = useSnapshot(appStore);
    const [inputDesignation, setInputDesignation] = React.useState<boolean>(
        false
    );
    const [
        isClickedBouttonValider,
        setIsClickedBouttonValider,
    ] = React.useState<boolean>(true);
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [designation, setDesignation] = useState<string>("");
    const [typeOfKDS, setTypeOfKDS] = useState<any>("");
    const [, setApplication] = useState<string>("");
    const [remark, setRemark] = useState<string>("");
    const [title, setTitle] = useState<string>("");

    const [isApplicationListExist, setIsApplicationListExist] = React.useState<
        boolean
    >(false);
    const [localNamesApplications, setLocalNamesApplications] = useState<
        string[]
    >([]);

    const isExist = React.useCallback(() => {
        let localNamesApplication: any[] = [];
        data.othersData !== undefined &&
            data.othersData.listDesignation !== undefined &&
            data.othersData.listDesignation.forEach((elt: any) => {
                localNamesApplication.push(elt);
            });
        return localNamesApplication;
    }, [data]);

    function shops() {
        let shops: any[] = [];
        selectedRows.subRows !== undefined &&
            selectedRows.subRows.forEach((row: any) => {
                shops.push(row.id_boutique);
            });
        return [...new Set(shops), "0"];
    }
    let ids: any[] = shops();
    async function addProject() {
        let id = uuid();
        let dataShop: any = {};
        dataShop[shopId] = {
            designation: shopName,
            id_boutique: shopId,
        };

        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/application/kds/project`;
        setIsClickedBouttonValider(false);
        const idProject: string = "PROJECT";

        let savedData = {
            userId: userID,
            shopId: oneShop ? [shopID, "0"] : ["0"],
            franchiseId: franchiseID,
            type: "Add",
            operatorId: operatorID,
            data: {
                [idProject]: {
                    id_project: idProject,
                    data_project: {
                        [id]: {
                            projectId: id,
                            template: {},
                            associates: oneShop ? dataShop : {},
                            designation: designation,
                            shopId: shopId,
                            note: remark,
                            status: "En attente",
                            typeOfKDS: typeOfKDS !== "" ? typeOfKDS : "",
                            isArchived: false,
                        },
                    },
                },
            },
        };
        try {
            fetch(apiUrlAdd, {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bareer ${localStorage.getItem("jwt")}`,
                },
                body: JSON.stringify(savedData),
                method: "POST",
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        throw Error("error");
                    }
                    toast.success(
                        `${t("The project is successfully added")!}`,
                        {
                            position: toast.POSITION.TOP_CENTER,
                            theme: "colored",
                            icon: (
                                <CheckboxIcon
                                    height={25}
                                    width={25}
                                    fill="white"
                                />
                            ),
                        }
                    );
                    setDesignation("");
                    setTypeOfKDS("");

                    setRemark("");
                    setIsClickedBouttonValider(true);
                    setDataIsUpdated!(true);
                });
        } catch (e) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }

    async function editProject() {
        setIsClickedBouttonValider(false);
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/application/kds/project`;
        const idProject: string = "PROJECT";
        let data = {
            userId: userID,
            shopId: oneShop ? ["0", shopID] : ids,
            franchiseId: franchiseID,
            operatorId: operatorID,
            data: {
                [idProject]: {
                    id_project: idProject,
                    data_project: {
                        [selectedRows.projectId]: {
                            projectId: selectedRows.projectId,
                            template: selectedRows.template,
                            associates: selectedRows.associates,
                            designation: designation,
                            note: remark,
                            status: selectedRows[t("Status")],
                            typeOfKDS: typeOfKDS !== "" ? typeOfKDS : "",
                            isArchived: false,
                            shopId: shopId,
                        },
                    },
                },
            },
        };
        try {
            fetch(apiUrlAdd, {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bareer ${localStorage.getItem("jwt")}`,
                },
                body: JSON.stringify(data),
                method: "POST",
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        throw Error("error");
                    }
                    toast.success(
                        `${t("The project was successfully changed")!}`,
                        {
                            position: toast.POSITION.TOP_CENTER,
                            theme: "colored",
                            icon: (
                                <CheckboxIcon
                                    height={25}
                                    width={25}
                                    fill="white"
                                />
                            ),
                        }
                    );
                    setDesignation("");
                    setTypeOfKDS("");
                    setRemark("");
                    setDataIsUpdated!(true);
                    setIsClickedBouttonValider(true);
                    setIsAddProject!(!isAddProject);
                });
        } catch (e) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }

    useEffect(() => {
        if (selectedRows.projectId) {
            setTitle(t("Modify project"));
            setDesignation(
                oneShop
                    ? selectedRows[t("Designation")]
                    : selectedRows[t("Designation")]
            );
            setApplication("PROJECT");
            setTypeOfKDS(selectedRows[t("Type of KDS")]);
            setRemark(selectedRows[t("Note")]);
        } else {
            setTitle(t("Add a project"));
            setDesignation("");
            setApplication("PROJECT");
            setRemark("");
            setTypeOfKDS("");
            setInputDesignation(false);
            setIsApplicationListExist(false);
            setIsClickedBouttonValider(true);
            // setExist(false);
        }

        // eslint-disable-next-line
    }, [selectedRows, t, isAddNewApplicationButtonClicked, isAddProject]);
    let isExistDesignation: any[] = isExist();
    React.useEffect(() => {
        isExist();
        setLocalNamesApplications(isExistDesignation);
        // eslint-disable-next-line
    }, [data, isExist]);

    React.useEffect(() => {
        if (isPlusIconClicked) {
            setInputDesignation(false);
            setIsApplicationListExist(false);
        }
    }, [isPlusIconClicked]);
    useEffect(() => {
        if (Object.values(selectedRows).length !== 0) {
            if (selectedRows[t("Designation")] !== "") {
                setInputDesignation(false);
            }
        }
        setIsClickedBouttonValider(true);
        // eslint-disable-next-line
    }, [selectedRows]);

    return (
        <React.Fragment>
            <AvForm className="card">
                <CustomCardHeader
                    className="d-flex align-items-center justify-content-between"
                    style={{ maxHeight: "76px" }}
                >
                    <h5 className="pt-3">{title}</h5>
                    <CrossIcon
                        style={{ cursor: "pointer" }}
                        height={13}
                        width={13}
                        onClick={() => {
                            setIsAddProject!(!isAddProject);
                            setIsClickedBouttonValider(true);
                            setDataIsUpdated!(true);
                            // if (isEdited === true) {
                            //     setIsActionsClicked(!isActionsClicked);
                            //     setActions(() => {
                            //         activateCheckbox();
                            //         setIsAddAppClicked!(!isAddAppClicked);
                            //         setIsEdited(false);
                            //         setIsConsult(false);
                            //     });
                            // } else {
                            //     activateCheckbox();
                            //     setIsConsult(false);
                            //     setIsAddAppClicked!(!isAddAppClicked);
                            // }
                        }}
                    />
                </CustomCardHeader>
                <CustomCardBody className="pl-3 pr-5">
                    <AvGroup>
                        <StyledLabel
                            htmlFor="name"
                            className="required__clz mt-3"
                        >
                            {t("Designation")}
                        </StyledLabel>
                        <StyledTextInput
                            autocomplete="off"
                            className={classnames("kds_inp_designation", {
                                input__clz:
                                    inputDesignation ||
                                    isApplicationListExist ||
                                    (designation.trim() === "" &&
                                        designation !== ""),
                            })}
                            id="designation"
                            name="designation"
                            placeholder={t("Write")}
                            type="text"
                            onChange={(e: any) => {
                                if (
                                    localNamesApplications.includes(
                                        e.target.value.trim()
                                    )
                                ) {
                                    setIsApplicationListExist(true);
                                } else {
                                    setIsApplicationListExist(false);
                                }

                                setDesignation(e.target.value);
                                setIsEdited!(true);
                                setIsClickedBouttonValider(true);
                                setInputDesignation(false);
                            }}
                            value={designation}
                            autoFocus
                        />
                        {inputDesignation ||
                        (designation.trim() === "" && designation !== "") ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("Please enter a designation")}
                            </div>
                        ) : null}
                        {isApplicationListExist ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("The name is already exists")!}
                            </div>
                        ) : null}
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel htmlFor="text" className="mt-3">
                            {t("Type of KDS")}
                        </StyledLabel>

                        <StyledSelectInput
                            isClearable
                            className={classnames("kds_drp_typeOfKds", {
                                // invalid__clz: inputChange || isApplicationListExist,
                                // "not-allowed-input__clz": devises.id,
                            })}
                            noOptionsMessage={() => t("No options")}
                            autocomplete="off"
                            name="change"
                            onChange={(e: any) => {
                                setIsClickedBouttonValider(true);
                                setIsEdited(true);
                                setTypeOfKDS(e === null ? "" : e.label);
                            }}
                            options={[
                                {
                                    label: t("Assembly"),
                                    value: t("Assembly"),
                                },
                                {
                                    label: t("Production"),
                                    value: t("Production"),
                                },
                                {
                                    label: t("Dessert"),
                                    value: t("Dessert"),
                                },
                            ]}
                            value={
                                typeOfKDS === ""
                                    ? null
                                    : {
                                          label: typeOfKDS,
                                          value: typeOfKDS,
                                      }
                            }
                            placeholder={`${t("Select")}…`}
                            type="text"
                        />
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel className="mt-3" htmlFor="remark">
                            {t("Remark")}
                        </StyledLabel>
                        <StyledTextInput
                            autocomplete="off"
                            id="remark"
                            name="remark"
                            placeholder={t("Write")}
                            type="text"
                            onChange={(e: any) => {
                                setIsClickedBouttonValider(true);
                                setRemark(e.target.value);
                                if (setIsEdited !== undefined)
                                    setIsEdited!(true);
                            }}
                            value={remark}
                            className={classnames("kds_inp_remark", {
                                // readOnly__clz: isConsult,
                            })}
                        />
                    </AvGroup>
                </CustomCardBody>
                <CustomCardFooter className="pt-1 pb-2">
                    <CustomSecondaryColorButton
                        outline
                        rounded
                        variant="light"
                        className="mr-2 cmn_btn_FRcancel"
                        onClick={() => {
                            setIsAddProject!(!isAddProject);
                            setDataIsUpdated!(true);
                        }}
                    >
                        <span> {t("Cancel")}</span>
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        rounded
                        disabled={!isClickedBouttonValider}
                        variant="primary"
                        onClick={() => {
                            if (designation === "") setInputDesignation(true);
                            if (
                                !isEdited ||
                                ((selectedRows !== undefined &&
                                    selectedRows[t("Designation")]) ===
                                    designation &&
                                    selectedRows !== undefined &&
                                    selectedRows[t("Type of KDS")] ===
                                        typeOfKDS &&
                                    selectedRows !== undefined &&
                                    selectedRows[t("Note")] === remark &&
                                    selectedRows !== undefined)
                            ) {
                                setIsModalOpened(true);
                            } else if (
                                designation.length !== 0 &&
                                designation.trim() !== "" &&
                                !isApplicationListExist &&
                                selectedRows.projectId === undefined
                            ) {
                                addProject();
                            } else if (
                                designation.length !== 0 &&
                                designation.trim() !== "" &&
                                !isApplicationListExist &&
                                selectedRows !== undefined &&
                                selectedRows.projectId !== undefined
                            ) {
                                editProject();
                            }
                        }}
                        className={classnames("cmn_btn_FRvalidate", {
                            // readOnly__clz: isConsult,
                            // "not-allowed-icon__clz": isConsult,
                        })}
                    >
                        {t("Validate")}
                    </CustomMainColorButton>
                </CustomCardFooter>
            </AvForm>
            <ConfirmationEditMessage
                setDataIsUpdated={setDataIsUpdated}
                isModalOpened={isModalOpened}
                setIsModalOpened={setIsModalOpened}
                isAddClicked={isAddProject}
                setIsAddClicked={setIsAddProject}
                setEditedData={setSelectedRow}
            />
        </React.Fragment>
    );
}
